export const isNativeApp = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  return typeof window.Capacitor?.isNativePlatform === 'function'
    ? window.Capacitor.isNativePlatform()
    : Boolean(window.Capacitor?.isNativePlatform);
};

export const isNativeAndroidApp = () => {
  if (!isNativeApp()) {
    return false;
  }
  const platform = window.Capacitor?.getPlatform?.();
  return platform === 'android';
};

export const supportsPinLogin = () => isNativeAndroidApp();

export const getClientAppId = () => {
  if (isNativeAndroidApp()) {
    return (process.env.REACT_APP_TITLE || 'BoltinPOS').toLowerCase();
  }
  return 'web';
};

export const isWebApp = () => !isNativeApp();
